import { Box } from '@mui/material'
import styled from '@emotion/styled'

export const Container = styled(Box, { shouldForwardProp: (prop) => prop !== 'compact' })<{ compact?: boolean }>`
  display: flex;
  justify-content: center;
  padding: ${({ compact }) => (compact ? 0 : '0 4px')};
`

export const Content = styled(Box, { shouldForwardProp: (prop) => prop !== 'compact' })<{ compact?: boolean }>`
  width: ${({ compact }) => (compact ? 'auto' : '100%')};
  padding: ${({ compact }) => (compact ? '1px 8px' : '6px 12px')};
  border-radius: 30px;
  font-size: ${({ compact }) => (compact ? '10px' : '12px')};
  font-style: normal;
  font-weight: 600;
  letter-spacing: 0.1px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  white-space: nowrap;
`
